module.exports = __webpack_public_path__ + "img/home.55644be0.svg";